


const colors = {
  light: {
     background: "#121212",
    surface: "#1E1E1E",
    sidebarBg: "#050712", // your elegant deep navy
    textPrimary: "#E5EAF2",
    textSecondary: "#A0AEC0",
    accent: "#60A5FA", // soft glowing blue
    accentLight: "rgba(96,165,250,0.15)",
    iconDefault: "#9CA3AF",
    divider: "rgba(255,255,255,0.08)",
    shadow: "4px 0 20px rgba(0,0,0,0.4)",
  },

  dark: {
    background: "#121212",
    surface: "#1E1E1E",
    sidebarBg: "#050712", // your elegant deep navy
    textPrimary: "#E5EAF2",
    textSecondary: "#A0AEC0",
    accent: "#60A5FA", // soft glowing blue
    accentLight: "rgba(96,165,250,0.15)",
    iconDefault: "#9CA3AF",
    divider: "rgba(255,255,255,0.08)",
    shadow: "4px 0 20px rgba(0,0,0,0.4)",
  },
  white:"#FFFFFF",
   // Add the missing colors that CustomAlert needs
  limeGreen: "#4CAF50",
  deleteBg: "#F44336", 
  darkGreen: "#2E7D32",
  red: "#F44336",
  darkRed: "#C62828",
  darkBlack: "#212121",

};

export default colors;